export default "__VITE_ASSET__1T9zk_79__"